import { Component, Input, ViewChild } from '@angular/core';
import {
  ObservationDefinition,
  ObservationDefinitionTarget,
} from 'app/mdm/lib/observation-definition/observation-definition';
import { EditableFlexTableComponent } from '@heda/core-hospital-ui';

@Component({
  selector: 'hw-observation-definition-targets-table',
  templateUrl: 'observation-definition-targets-table.component.html',
})
export class ObservationDefinitionTargetsTableComponent {
  @Input() public editMode: boolean = true;
  @Input() public definition: ObservationDefinition;
  @ViewChild('targetsTable') public targetsTable: EditableFlexTableComponent<ObservationDefinitionTarget>;

  public defaultTargetRow: ObservationDefinitionTarget = new ObservationDefinitionTarget();

  public validate(): boolean {
    return this.targetsTable?.validate();
  }
}
